/**
 * Created by muze on 8/10/2017 AD.
 */
import React from 'react'
import { compose, withState, lifecycle } from 'recompose'
import PropTypes from 'prop-types'
import BluePrintRenderer from 'components/Canvas/renderer'
import { readOnData } from 'firebase/functions'
import { connect } from 'react-redux';
import { selectStoreId } from 'store/preferences/selectors'
import { Loader } from 'semantic-ui-react'
import withStoreTheme from 'store/theme/withStoreTheme'
import withTheme from 'hocs/bases/withTheme'

const mapStateToProps = (state) => ({
  storeId: selectStoreId(state)
});

const Demo = compose(
  withStoreTheme(),
  withTheme,
  connect(mapStateToProps),
  withState('bluePrint', 'setBluePrint', null),
  lifecycle({
    componentDidMount() {
      const { storeId, setBluePrint } = this.props
      readOnData(storeId, 'demo2', (result) => setBluePrint(result))
    },
  })
)(
  ({
    bluePrint,
  }) => {
    if(!bluePrint){
      return <Loader active size="big">Loading...</Loader>
    }
    return (
      <BluePrintRenderer bluePrint={bluePrint} />
    )
  }
)

Demo.propTypes = {}
Demo.defaultProps = {}

export default Demo



// WEBPACK FOOTER //
// ./src/pages/Demo/demo2.js